import React from 'react';
import './company-select.css';

export class CompanySelect extends React.Component {
    menuRef = React.createRef();

    onEvent = event => {
        const { onChangeValue } = this.props;
        if (event.detail.event === 'validated' && onChangeValue && event.detail.value !== this.props.value) {
            onChangeValue(event.detail.value, event.detail.label);
        }
    };

    detectChange = (mutationList, observer) => {
        if (this.menuRef.current.querySelector('.select-menu')) {
            this.props.showNumberField(true);
            observer.disconnect();
        }
    };

    componentDidMount() {
        this.observer = new MutationObserver(this.detectChange);
        this.observer.observe(this.menuRef.current, { childList: true });
        this.menuRef.current.addEventListener('fieldEvent', this.onEvent);
    }

    componentWillUnmount() {
        this.menuRef.current.removeEventListener('fieldEvent', this.onEvent);
        this.observer.disconnect();
    }

    render() {
        const { label, required, value, onChangeValue, showNumberField, ...restProps } = this.props;

        return (
            <flos-select-menu
                ref={this.menuRef}
                {...restProps}
                company-list
                type-ahead
                label={label}
                is-required={required ? true : undefined}
            />
        );
    }
}
